import { createAction } from 'redux-actions';
import { isNull, concat } from 'lodash';

import { callApi, getEndpoint } from '../../../utils/api';
import { getAPITransactionType } from '../../../utils/transactions-util';

const EXISTING_BANK = 'EXISTING_BANK';
const EXISTING_BANK_SERVICE_FEATURES = 'EXISTING_BANK_SERVICE_FEATURES';

const REGISTER_NEW_BANK = 'ADD_EXISTING_BANK';
const SELECT_SHOW_MORE_BANKS = 'SELECT_SHOW_MORE_BANKS';

export default function existingBanks(
  state = {
    existingBanks: [],
    newBanks: [],
    agreementMap: {},
    status: 'PRE_FETCH',
    hasFailed: false,
    fetchingAccounts: false,
    error: null,
    isLoaded: false,
    isLoading: true,
    show: false,
  },
  { payload, type }
) {
  switch (type) {
    case `${EXISTING_BANK}_PENDING`:
      return {
        ...state,
        fetchingAccounts: true,
        existingBanks: state.existingBanks ? state.existingBanks : [],
        status: 'FETCHING',
        isLoaded: false,
        isLoading: true,
      };
    case `${EXISTING_BANK}_FULFILLED`:
      return {
        ...state,
        existingBanks: isNull(payload.body) ? [] : payload.body,
        fetchingAccounts: false,
        status: 'RETRIEVED ACCOUNTS',
        isLoaded: true,
        isLoading: false,
      };
    case `${EXISTING_BANK}_REJECTED`:
      return {
        ...state,
        existingBanks: state.existingBanks ? state.existingBanks : [],
        fetchingAccounts: false,
        status: 'FAILED',
        hasFailed: true,
        error: payload,
        isLoaded: false,
        isLoading: false,
      };
    case `${EXISTING_BANK_SERVICE_FEATURES}_PENDING`:
      return {
        ...state,
        existingBanks: state.existingBanks ? state.existingBanks : [],
      };
    case `${EXISTING_BANK_SERVICE_FEATURES}_FULFILLED`: {
      const { existingBanks } = state;
      const newExistingBanks = existingBanks.map((bank) => {
        bank['serviceFeatures'] = payload.body[bank.bankAgreementID] || {};
        return bank;
      });
      return {
        ...state,
        existingBanks: newExistingBanks,
      };
    }
    case `${EXISTING_BANK_SERVICE_FEATURES}_REJECTED`:
      return {
        ...state,
        existingBanks: state.existingBanks ? state.existingBanks : [],
        fetchingAccounts: false,
        status: 'FAILED',
        hasFailed: true,
        error: payload,
        isLoaded: false,
      };
    case `${REGISTER_NEW_BANK}_FULFILLED`:
      return {
        ...state,
        newBanks: concat(state.newBanks, [payload]),
      };
    case `${SELECT_SHOW_MORE_BANKS}_FULFILLED`:
      return {
        ...state,
        show: payload,
      };
    default:
      return state;
  }
}

export const getExistingBanks = () => {
  return () => {
    const action = createAction(EXISTING_BANK)(
      callApi(
        `${getEndpoint(
          'existingBanks'
        )}?transactionType=${getAPITransactionType()}`
      )
    );
    return action;
  };
};

export const getExistingBanksSerivceFeatures = () => {
  return () => {
    const action = createAction(EXISTING_BANK_SERVICE_FEATURES)(
      callApi(`${getEndpoint('existingBanksServiceFeatures')}`)
    );
    return action;
  };
};

export const registerNewBank = (bank, action) => {
  return (dispatch) => {
    dispatch(createAction(`${REGISTER_NEW_BANK}_FULFILLED`)(bank));
    if (typeof action === 'function') {
      dispatch(action());
    }
  };
};

export const showMoreBanks = (show) => (dispatch) => {
  const action = createAction(`${SELECT_SHOW_MORE_BANKS}_FULFILLED`)(show);
  dispatch(action);
};
